import React from "react";
import "./imageContentBox.scss";

const ImageContentBox = ({ img, ImageContentData }) => {
  return (
    <>
      <div className="row img_content_row">
        <div className="col-lg-5 img_content_col" data-aos="fade-up">
          <div className="img_wrapper">
            <img src={img} alt="founder" className="box_img" />
          </div>
        </div>
        <div className="col-lg-7 img_content_col" data-aos="fade-up">
          {ImageContentData.map((item, i) => (
            <div className="content_wrapper" key={i}>
              <h2 className="section_heading48">{item.title}</h2>
              {item?.description.map((desc, index) => (
                <p
                  className="section_desc22"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: desc }}
                ></p>
              ))}
              {/* <a href={item.link} target="_blank" rel="noreferrer">
                <img
                  src={aboutLinkedIn}
                  alt="linkedIn"
                  className="linkedin_icon"
                />
              </a> */}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ImageContentBox;
